var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("section", { attrs: { id: "basic" } }, [
      _c("h2", {
        directives: [
          {
            name: "t",
            rawName: "v-t",
            value: "Setting.title01",
            expression: "'Setting.title01'",
          },
        ],
      }),
      _c(
        "div",
        { staticClass: "language" },
        [
          _c("h3", [_vm._v(_vm._s(_vm.$t("Setting.langTitle")))]),
          _c(
            "el-select",
            {
              attrs: { size: "small" },
              on: { change: _vm.setLocaleSetting },
              model: {
                value: _vm.$i18n.locale,
                callback: function ($$v) {
                  _vm.$set(_vm.$i18n, "locale", $$v)
                },
                expression: "$i18n.locale",
              },
            },
            _vm._l(_vm.languages, function (lang, index) {
              return _c("el-option", {
                key: index,
                attrs: { value: lang.code, label: lang.label },
              })
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "timezone" },
        [
          _c("h3", [_vm._v(_vm._s(_vm.$t("Setting.timezoneTitle")))]),
          _c(
            "el-select",
            {
              staticClass: "timezones",
              attrs: { size: "medium" },
              on: { change: _vm.setTimezone },
              model: {
                value: _vm.currentTimezone,
                callback: function ($$v) {
                  _vm.currentTimezone = $$v
                },
                expression: "currentTimezone",
              },
            },
            _vm._l(_vm.timezones, function (tz) {
              return _c("el-option", {
                key: tz.city,
                attrs: {
                  value: tz.city,
                  label:
                    "GMT" +
                    tz.offset +
                    " " +
                    _vm.$t("MetaZones." + tz.metazone) +
                    " (" +
                    _vm.$t("TimezoneCities." + tz.city) +
                    ")",
                },
              })
            }),
            1
          ),
          _c("el-tooltip", { attrs: { placement: "top" } }, [
            _c("div", {
              attrs: { slot: "content" },
              domProps: { innerHTML: _vm._s(_vm.$t("Setting.timezoneTxt")) },
              slot: "content",
            }),
            _c("i", { staticClass: "el-icon-question" }),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }